<template>
    <AppLayout
        page="/upload-image"
        pageTitle="Upload Image"
        :tabs="true"
        ref="appLayout"
    >
        <v-form ref="form">
            <v-row>
                <v-col cols="12" xs="12" sm="6" lg="4">
                    <v-card class="soli-round">
                        <v-container>
                            <v-col class="flex justify-center hidden">
                                <input
                                    type="file"
                                    ref="photo"
                                    @input="convertPhoto($event)"
                                />
                            </v-col>
                            <v-row
                                v-if="errors.photo"
                                class="justify-center w-full my-1"
                                ><small class="red--text">{{
                                    errors.photo
                                }}</small></v-row
                            >
                            <v-row :class="['my-3 justify-center w-full']">
                                <v-btn
                                    text
                                    small
                                    plain
                                    color="dark"
                                    :class="['soli-round']"
                                    type="button"
                                    @click.native.prevent="selectNewPhoto"
                                    >Upload Photo
                                </v-btn>
                            </v-row>
                        </v-container></v-card
                    >
                </v-col>
            </v-row>
        </v-form>

        <v-dialog v-model="showImageEditor" max-width="425" class="soli-round">
            <v-card class="soli-round" style="overflow: hidden">
                <v-container v-if="cropperLoading">
                    <v-skeleton-loader class="soli-round" type="image" />
                </v-container>
                <VueCropper
                    v-show="!cropperLoading"
                    ref="cropper"
                    :src="null"
                    :aspectRatio="1"
                    alt="Loading"
                />
                <v-text-field
                    label="Name"
                    class="pa-3"
                    v-model="photoForm.imageName"
                    hide-details
                    outlined
                    dense
                ></v-text-field>
                <v-card-actions class="justify-end">
                    <v-btn
                        plain
                        color="soli-grey soli-round"
                        text
                        @click="closeModal(() => (showImageEditor = false))"
                        >Cancel</v-btn
                    >
                    <v-btn
                        class="soli-blue white--text soli-round"
                        :loading="imageLoading"
                        @click="
                            updatePhoto(),
                                closeModal(() => (showImageEditor = false))
                        "
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <SoliSnack
            v-if="showMessage"
            @hide="showMessage = false"
            :text="$page.props.successMessage"
        ></SoliSnack>
    </AppLayout>
</template>

<script>
import AppLayout from "./../Layouts/AppLayout.vue";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";

export default {
    name: "ImageUpload",
    props: ["errors"],
    components: { VueCropper, AppLayout },
    data: function () {
        return {
            photoForm: this.$inertia.form({
                _method: "POST",
                photo: null,
                imageName: null,
            }),
            cropperLoading: false,
            imageLoading: false,
            photoFile: null,
            selectedPhoto: null,
            showImageEditor: false,
            showMessage: false,
        };
    },
    methods: {
        selectNewPhoto(e) {
            this.$refs.photo.click();
            this.cropperLoading = true;
        },
        convertPhoto(e) {
            this.photoFile = e.target.files[0];
            this.showImageEditor = true;
            let reader = new FileReader();
            reader.onload = (e) => {
                this.selectedPhoto = e.target.result;
                this.$refs.cropper.replace(this.selectedPhoto);
                this.$nextTick(() => {
                    this.resizeImage(
                        this.photoFile,
                        this.$refs.cropper.$refs.img
                    );
                });
            };

            reader.readAsDataURL(this.photoFile);
        },
        resizeImage(file, img) {
            let canvas = document.createElement("canvas");
            let ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            let maxWidth = 1000;
            let maxHeight = 1000;
            let width = img.width;
            let height = img.height;
            let aspectRatio = Math.min(maxWidth / width, maxHeight / height);

            let adjustedWidth = width * aspectRatio;
            let adjustedHeight = height * aspectRatio;

            canvas.width = adjustedWidth;
            canvas.height = adjustedHeight;
            ctx.drawImage(img, 0, 0, adjustedWidth, adjustedHeight);
            let dataUrl = canvas.toDataURL(file.type);
            this.$refs.cropper.replace(dataUrl);
            this.cropperLoading = false;
        },
        updatePhoto() {
            this.imageLoading = true;
            let croppedImage = this.$refs.cropper
                .getCroppedCanvas()
                .toDataURL(this.photoFile.type);
            this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
                this.photoForm.photo = blob;
                this.photoForm.post(`/upload-image/save`, {
                    preserveScroll: true,
                    onSuccess: () => {
                        this.photoForm.reset();
                        this.$refs.photo.value = null;
                        this.imageLoading = false;
                        this.showMessage = true;
                    },
                    onError: (error) => {
                        console.log(error.photo);
                        this.imageLoading = false;
                    },
                });
            });
        },
    },
};
</script>
